import React from "react";
import { Button, Paper, TextField, MenuItem, Grid } from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
import { Formik, Field } from "formik";
import {
  OBTENER_CATEGORIAS_PERSONAS,
  OBTENER_PERSONAS,
  EDITAR_INFO_PERSONA,
  OBTENER_INFO_PERSONA,
} from "../../../../graphql/personas";

const FrmEditarPersona = ({
  setOpenDialog,
  setOpenSnackBar,
  setErrorGraph,
  id,
}) => {
  const { data, loading, error } = useQuery(OBTENER_CATEGORIAS_PERSONAS);
  const {
    data: dPersona,
    loading: lPersona,
    error: ePersona,
  } = useQuery(OBTENER_INFO_PERSONA, {
    variables: {
      id: id,
    },
  });

  const [editarPersona] = useMutation(EDITAR_INFO_PERSONA, {
    update(cache, { data: { editarPersona } }) {
      const { obtenerPersonas } = cache.readQuery({
        query: OBTENER_PERSONAS,
      });
      cache.writeQuery({
        query: OBTENER_PERSONAS,
        data: {
          obtenerPersonas: [...obtenerPersonas, editarPersona],
        },
      });
    },
  });

  const handleOpenDialog = () => {
    setOpenDialog(false);
  };

  if (lPersona) return <h1>Obteniendo información a editar...</h1>;
  if (loading) return <h1>Generando categorías</h1>;

  //Set values
  const { obtenerPersona } = dPersona;
  const { listaCatPersonas } = data;

  const onSubmit = async (values, formikValues) => {
    try {
      const dataInput = await editarPersona({
        variables: {
          input: {
            id: values.id,
            nombre: values.nombre.toUpperCase(),
            apellidos: values.apellidos.toUpperCase(),
            CatPersonaId: values.CatPersonaId,
          },
        },
      });

      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: dataInput.data.editarPersona,
        severity: "success",
      });
      setOpenDialog(false);
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          id: obtenerPersona.id,
          nombre: obtenerPersona.nombre,
          apellidos: obtenerPersona.apellidos,
          CatPersonaId: obtenerPersona.CatPersonaId,
        }}
        onSubmit={onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          handleChange,
          handleBlur,
          handleReset,
          isSubmitting,
        }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <Grid container alignItems="flex-start" spacing={3}>
              <Grid item xs={12}>
                <Field name="id" hidden />
                <Field name="nombre">
                  {({
                    field, // { name, value, onChange, onBlur }
                    form: { touched, errors },
                    meta,
                  }) => (
                    <TextField
                      {...field}
                      label="Nombre (s)"
                      variant="standard"
                      fullWidth
                    />
                  )}
                </Field>
              </Grid>
              <Grid item xs={12}>
                <Field name="apellidos">
                  {({
                    field, // { name, value, onChange, onBlur }
                    form: { touched, errors },
                    meta,
                  }) => (
                    <TextField
                      {...field}
                      label="Apellidos"
                      variant="standard"
                      fullWidth
                    />
                  )}
                </Field>
              </Grid>
              <Grid item xs={12}>
                <Field name="CatPersonaId">
                  {({
                    field, // { name, value, onChange, onBlur }
                    form: { touched, errors },
                    meta,
                  }) => (
                    <TextField
                      {...field}
                      select
                      label="Categoría *"
                      helperText="Seleccione una categoría para este registro"
                      variant="standard"
                      fullWidth
                    >
                      {listaCatPersonas.map((options) => (
                        <MenuItem key={options.clave} value={options.clave}>
                          {options.categoria}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Field>
              </Grid>
            </Grid>
            <Button type="submit">Editar</Button>
            <Button onClick={() => handleOpenDialog()}>Cerrar</Button>
          </form>
        )}
      </Formik>
    </>
  );
};

export default FrmEditarPersona;
